import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { t } from '../i18n/nl.js';

export default function ProtectedRoute() {
  const { session, loading, slowStart } = useAuth();

  if (loading) {
    return (
      <div className="loading-center" style={{ height: '100vh', flexDirection: 'column', gap: '16px' }}>
        <div className="spinner" />
        {slowStart && (
          <p style={{ maxWidth: '360px', textAlign: 'center', color: 'var(--text-secondary, #666)' }}>
            {t('auth.startTraag')}
          </p>
        )}
      </div>
    );
  }

  if (!session) return <Navigate to="/login" replace />;
  return <Outlet />;
}
